import { render, staticRenderFns } from "./trigger.vue?vue&type=template&id=b4ad88d4&scoped=true"
import script from "./trigger.vue?vue&type=script&lang=js"
export * from "./trigger.vue?vue&type=script&lang=js"
import style0 from "./trigger.vue?vue&type=style&index=0&id=b4ad88d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ad88d4",
  null
  
)

export default component.exports